import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import PropTypes from 'prop-types';
import './CustomCheckbox.less';

const CustomCheckbox = ({ 
  checked, 
  onChange, 
  label, 
  disabled = false, 
  className = '', 
  ...props 
}) => {
  return (
    <div className={`custom-checkbox-item ${className}`}>
      <Checkbox
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="custom-checkbox"
        {...props}
      />
      {label && (
        <label 
          className="custom-checkbox-label"
          onClick={() => !disabled && onChange({ checked: !checked })}
        >
          {label}
        </label>
      )}
    </div>
  );
};

CustomCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CustomCheckbox; 